<div class="mainPage scrollPage templatePage">
    <div class="container">
        <div class="pt-4 pb-3 mb-5">


            <button type="button" class="btn btn-outline-lemken btn-lg btn-block mainBtn"
                    aria-label="Go to the filter page"
                    routerLink="/filter">
                <div class="row align-items-center">
                    <div class="col-1 mainIcon">
                        <fa-icon icon="search" size="4x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div class="col  text-left h3 text-break" style="hyphens: auto;">
                        {{ 'mainPage.menuFilter' | translate }}
                    </div>
                </div>
            </button>

            <button type="button" class="btn btn-outline-lemken btn-lg btn-block mainBtn"
                    aria-label="Go to the comparison"
                    routerLink="/comparison">
                <div class="row align-items-center">
                    <div class="col-1 mainIcon">
                        <fa-icon icon="balance-scale" size="4x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div class="col  text-left h3 text-break" style="hyphens: auto;">
                        {{ 'mainPage.menuComparison' | translate }}
                    </div>
                </div>
            </button>

            <button type="button" class="btn btn-outline-lemken btn-lg btn-block mainBtn"
                    aria-label="Go to the doc part"
                    routerLink="/doc">
                <div class="row align-items-center">
                    <div class="col-1 mainIcon">
                        <fa-icon icon="file" size="4x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div class="col  text-left h3 text-break" style="hyphens: auto;">
                        {{ 'mainPage.menuDoc' | translate }}
                    </div>
                </div>
            </button>

            <button type="button" class="btn btn-outline-lemken btn-lg btn-block mainBtn"
                    aria-label="Go to the setting part"
                    routerLink="/setting">
                <div class="row align-items-center">
                    <div class="col-1 mainIcon">
                        <fa-icon icon="cogs" size="4x" [fixedWidth]="true"></fa-icon>
                    </div>
                    <div class="col  text-left h3 text-break" style="hyphens: auto;">
                        {{ 'mainPage.menuSetting' | translate }}
                    </div>
                </div>
            </button>

            <app-data-validity-mention></app-data-validity-mention>


        </div>

    </div>
    <div class="fixed-bottom bottomPage bg-white">
        <div class="text-center small">
            {{ 'mainPage.copyright' | translate }} {{ version }}
        </div>
    </div>
</div>
